export default "__VITE_ASSET__D_GmJJ1l__";